/* eslint-disable */
import React from 'react'
import Fade from 'react-reveal/Fade';
import { Grid, Row, Col } from 'react-flexbox-grid'
import { useTranslation } from "react-i18next";

import CardLong from '../../components/card-long'
import IcWhy from '../../static/icons/ic-easy-order.svg'
import IcHome from '../../static/icons/ic-service-survey.svg'
import IcClock from '../../static/icons/ic-transparent-price.svg'
import IcMap from '../../static/icons/ic-quality-work.svg'
import { TitleOne, TextBodyOne, BorderText } from '../../components/text'
import { Style } from './why-massage.styles'

const WhyHaloMassage = () => {
  const { t } = useTranslation();

  return (
    <Style id="why-massage">
      <Grid>
        <Row>
          <Col sm={12} xs={12} lg={12} className="column-bottom">
            <TitleOne className="title-one" display="block" align="center">
              {t('pageServiceAcJakarta.part5')}
            </TitleOne>
            <TextBodyOne
              className="title-body-one"
              display="block"
              align="center"
            >
              {t('pageServiceAcJakarta.part6')}
            </TextBodyOne>
            <div className="border">
              <Fade left>
                <BorderText background="linear-gradient(86deg, #ff8270, #e3eff9)"></BorderText>
              </Fade>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={6} xs={12} md={6} lg={6} className="bottom-column">
            <CardLong
              hover
              imageSize="120px"
              options={{
                image: IcWhy,
                title: t('pageServiceAcJakarta.part7'),
                desc: t('pageServiceAcJakarta.part8')
              }}
            ></CardLong>
          </Col>
          <Col sm={6} xs={12} md={6} lg={6} className="bottom-column">
            <CardLong
              imageSize="120px"
              hover
              options={{
                image: IcHome,
                title: t('pageServiceAcJakarta.part9'),
                desc: t('pageServiceAcJakarta.part10')
              }}
            ></CardLong>
          </Col>
          <Col sm={6} xs={12} md={6} lg={6} className="bottom-column">
            <CardLong
              hover
              imageSize="120px"
              options={{
                image: IcClock,
                title: t('pageServiceAcJakarta.part11'),
                desc: t('pageServiceAcJakarta.part12')
              }}
            ></CardLong>
          </Col>

          <Col sm={6} xs={12} md={6} lg={6} className="bottom-column">
            <CardLong
              hover
              imageSize="120px"
              options={{
                image: IcMap,
                title: t('pageServiceAcJakarta.part13'),
                desc: t('pageServiceAcJakarta.part14')
              }}
            ></CardLong>
          </Col>
        </Row>
      </Grid>
    </Style>
  )
}

export default WhyHaloMassage
